// Styles for AccountMetrics go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledAccountMetrics = styled.div`
  .accountmetrics {
    &__container {
      gap: ${toRem(8)};
    }

    &__separator {
      height: ${toRem(12)};
      width: ${toRem(1)};
      background: ${baseVariables.color['neutral40']};
    }

    &__points {
      gap: ${toRem(8)};
    }

    &__loader {
      width: 40%;
      height: ${toRem(24)};
    }

    &__icon {
      line-height: 0;
    }
  }
`;
